function cov_1nthw0j7ka() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/constants/MAPBOX.ts";
    var hash = "037a84346c1eb1741f8813594db645a06f4d52ca";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/constants/MAPBOX.ts",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 22
                },
                end: {
                    line: 101,
                    column: 1
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            "0": 0
        },
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "037a84346c1eb1741f8813594db645a06f4d52ca"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_1nthw0j7ka = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1nthw0j7ka();
import { MAPBOX_CORE } from 'vio-constants';
export const MAPBOX = (cov_1nthw0j7ka().s[0]++, Object.assign(Object.assign({}, MAPBOX_CORE), { CLOUD_PROVIDERS: {
        AWS: 'aws',
        AZURE: 'azure',
        GOOGLE: 'google'
    }, DEFAULT_OPTIONS: Object.assign(Object.assign({}, MAPBOX_CORE.DEFAULT_OPTIONS), { MARKET_LEVEL_MAX_ZOOM: 8.6 }), GOOGLE_MAPS: {
        DESTINATION_PREFIX: 'destination=',
        DIRECTIONS_URL: 'https://www.google.com/maps/dir/?api=1&'
    }, ICONS: {
        IX_MARKER: 'ix-icon.svg',
        OFFLINE_BACKGROUND_COLOR: '#8E8E8E',
        OFFLINE_BORDER_COLOR: '#00C5DC',
        OFFLINE_IX_MARKER: 'offline-ix-icon.svg',
        OFFLINE_SITE_MARKER: 'offline-site-marker.svg',
        OFFLINE_TEXT_COLOR: '#CCCCCC',
        ONLINE_BACKGROUND_COLOR: '#51D5A0',
        ONLINE_BORDER_COLOR: '#56C498',
        ONLINE_TEXT_COLOR: '#FFFFFF',
        SITE_MARKER: 'map-marker.svg',
        SIZE: 24
    }, LAYERS: {
        CLOUD_ON_RAMP_LAYER: {
            AWS_LAYER: 'aws',
            AZURE_LAYER: 'azure',
            GOOGLE_LAYER: 'google',
            ICON: {
                ALLOW_OVERLAP: true,
                IMAGE: '{icon}',
                SIZE: 1
            }
        },
        EDGE_SITE_LAYERS: {
            EDGE_SITE_CLUSTER_COUNT_LAYER: 'vio-ke-site-cluster-count',
            EDGE_SITE_CLUSTER_ICON: 'site-cluster',
            EDGE_SITE_CLUSTER_LAYER: 'vio-ke-site-cluster',
            EDGE_SITE_ICON: 'site-marker',
            EDGE_SITE_LAYER: 'vio-ke-site',
            ICON: {
                ALLOW_OVERLAP: true,
                IMAGE: '{icon}',
                SIZE: 0.75
            },
            MIXED_EDGE_SITE_CLUSTER_ICON: 'mixed-site-cluster',
            OFFLINE_EDGE_SITE_CLUSTER_ICON: 'offline-site-cluster',
            OFFLINE_EDGE_SITE_ICON: 'offline-site-marker'
        },
        INTERNET_EXCHANGE_LAYERS: {
            ICON: {
                ALLOW_OVERLAP: true,
                IMAGE: '{icon}',
                SIZE: 0.75
            },
            IX_CLUSTER_COUNT_LAYER: 'ix-cluster-count',
            IX_CLUSTER_ICON: 'ix-cluster',
            IX_CLUSTER_LAYER: 'ix-cluster',
            IX_ICON: 'ix',
            IX_LAYER: 'ix',
            MIXED_IX_CLUSTER_ICON: 'mixed-ix-cluster',
            OFFLINE_IX_CLUSTER_ICON: 'offline-ix-cluster',
            OFFLINE_IX_ICON: 'offline-ix'
        },
        MARKET_LAYERS: {
            CLUSTER_RADIUS: 40,
            MARKET_CLUSTER_COUNT_LAYER: 'vio-market-cluster-count',
            MARKET_CLUSTER_LAYER: 'vio-market-cluster',
            MARKET_COUNT_LAYER: 'vio-market-count',
            MARKET_LAYER: 'vio-market'
        }
    }, POPUP: Object.assign(Object.assign({}, MAPBOX_CORE.POPUP), { OFFSETS: Object.assign(Object.assign({}, MAPBOX_CORE.POPUP.OFFSETS), { CLOUD_ONRAMP_POPUP: [0, -25] }) }), SOURCES: {
        AWS: 'aws',
        AZURE: 'azure',
        EDGE_SITES: 'edge-sites',
        GOOGLE: 'google',
        IXS: 'ixs',
        MARKETS: 'markets'
    } }));
